import request from "../Tools/request/request";

// 日志记录-列表
export function getLogList(data) {
    return request({
        url: "/operlog/list",
        method: "post",
        data,
    });
}
